// extracted by mini-css-extract-plugin
module.exports = {"siderCollapsedWidth":"40px","button":"button--132WR","error":"error--3_WST"};